t = require('views/internal/teacup-with-helpers')('action')

module.exports = t.renderable (data, context, options) ->
  { saved, dateLastEdited, date, url } = data
  { board, organization, canReply, canReplyAll, canDelete, canEdit, canAttachLink, showInlineReactionButton, canReact } = context
  { showOptions, needsDate } = options

  t.div '.phenom-meta.quiet', ->
    if needsDate
      if saved
        if url
          t.a '.date.js-hide-on-sending.js-highlight-link', { dt: date, href: url }
        else
          t.span '.date.js-hide-on-sending', { dt: date, href: url }
      if dateLastEdited
        t.span '.js-date-title.js-hide-on-sending', { dt: dateLastEdited }, ->
          t.text ' '
          t.format 'edited'
    t.span { class: t.classify('js-spinner': true, hide: saved) }, ->
      t.format 'sending-ellipsis'
      t.raw '&nbsp;'

    if board
      { boardPLevelAltText, boardPLevelIconClass } = context
      t.text ' - '
      t.format 'on-board-name', { url: board.url, name: board.name, boardPLevelAltText, boardPLevelIconClass }

    if organization
      { orgPLevelAltText, orgPLevelIconClass } = context
      t.text ' - '
      t.format 'on-organization-name', { url: organization.url, name: organization.name, orgPLevelAltText, orgPLevelIconClass }

    if showOptions
      t.span '.js-hide-on-sending.middle', ->
        needsDash = !context.isShowCards
        renderDashWhenNeeded = ->
          if needsDash
            t.text " - "
          else
            needsDash = true

        if canReply
          renderDashWhenNeeded()
          t.a {
            href: '#'
            class:
              if canReplyAll
                'js-reply-to-all-action'
              else
                'js-reply-to-action'
          }, ->
            t.format 'reply'
        if canEdit
          renderDashWhenNeeded()
          t.a '.js-edit-action', { href: '#' }, ->
            t.format 'edit'
        if canAttachLink
          renderDashWhenNeeded()
          t.a '.js-attach-link', { href: '#' }, ->
            t.format 'attach link'
        if canDelete
          renderDashWhenNeeded()
          t.a '.js-confirm-delete-action', { href: '#' }, ->
            t.format 'delete'

        t.span '.edits-warning.quiet', ->
          renderDashWhenNeeded()
          t.format 'you-have-unsaved-edits-on-this-field'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/action_footer.coffee